import { isMobile } from 'app-constants';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { purple, deepOrange, grey } from '@material-ui/core/colors';

export const useStyles = makeStyles((theme) => createStyles({
    button: {
      textTransform: 'none',
      borderRadius: 20,
      width: isMobile ? 'auto' : 130,
      minWidth: 80,
      color: theme.palette.getContrastText(purple[500]),
      backgroundColor: deepOrange[700],
      '&:hover': {
        backgroundColor: deepOrange[700]
      }
    },
    root: {
      textTransform: 'none',
      borderRadius: 20,
      width: isMobile ? 'auto' : 130,
      minWidth: 80,
      color: theme.palette.getContrastText(grey[200]),
      backgroundColor: grey[200],
      '&:hover': {
        backgroundColor: grey[200]
      }
    }
  }));

export default {};
